import { render } from "./HomeSection.vue?vue&type=template&id=5c507aa9&scoped=true"
import script from "./HomeSection.vue?vue&type=script&lang=js"
export * from "./HomeSection.vue?vue&type=script&lang=js"

import "./HomeSection.vue?vue&type=style&index=0&id=5c507aa9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c507aa9"]])

export default __exports__